import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CallService, CallData } from './services/call.service';
import { MessagingService } from './services/messaging.service';
import { VideoCallComponent } from './components/video-call/video-call.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    VideoCallComponent,
    CommonModule
  ]
})
export class AppComponent implements OnInit {
  isCallActive: boolean = false;
  currentCallData: CallData | null = null;
  permissionAsked = false;

  constructor(
    private callService: CallService,
    private messagingService: MessagingService
  ) { }

  ngOnInit() {
    this.callService.callActive$.subscribe(active => this.isCallActive = active);
    this.callService.callData$.subscribe(callData => this.currentCallData = callData);

    const perm = Notification.permission; // 'granted' | 'denied' | 'default'
    const askedBefore = localStorage.getItem('permissionAsked') === 'true';
    this.permissionAsked = (perm === 'granted' || perm === 'denied' || askedBefore);
  }

  enableNotifications() {
    this.permissionAsked = true;
    localStorage.setItem('permissionAsked', 'true');
    this.messagingService.requestPermissionAndGetToken();
  }

  // The onCallEnded method has been removed as it is redundant.
  // The call service now handles the call state reactively.
  // Please remove the (callEnded)="onCallEnded()" from your app.component.html file.
}
